// MB look-alike: split the desktop menu around the centred logo (draft theme only)
(function(){
  function split(){
    var inner=document.querySelector('.header__inner');
    var nav=inner&&inner.querySelector('.header__nav');
    var logo=inner&&inner.querySelector('.header__logo');
    if(!nav||!logo||nav.dataset.mbSplit) return;
    var ul=nav.querySelector('.header__nav-items');
    var items=[].slice.call(ul.children);
    if(items.length<4) return;
    var cut=Math.floor(items.length/2);
    var nav2=nav.cloneNode(false); nav2.classList.add('mb-nav-right');
    var ul2=ul.cloneNode(false);
    items.slice(cut).forEach(function(li){ul2.appendChild(li);});
    nav2.appendChild(ul2); logo.parentNode.insertBefore(nav2, logo.nextSibling);
    nav.classList.add('mb-nav-left'); nav.dataset.mbSplit='1';
    inner.classList.add('mb-split');
  }
  if(document.readyState!=='loading') split(); else document.addEventListener('DOMContentLoaded',split);
})();

// MB look-alike: "Save X%" badge next to the PDP price; recalculated whenever the theme re-renders the price (variant change)
(function(){
  function num(el){ if(!el) return 0; var m=(el.textContent||'').replace(/,/g,'').match(/(\d+(?:\.\d+)?)/); return m?parseFloat(m[1]):0; }
  function sync(){
    var p=document.querySelector('.product__price'); if(!p) return;
    var was=num(p.querySelector('del')), now=num(p.querySelector('ins'));
    var b=p.querySelector('.mb-save');
    if(!(was>now&&now>0)){ if(b) b.remove(); return; }
    var pct=Math.round((was-now)/was*100);
    if(!b){ b=document.querySelector('.mb-save')||document.createElement('span'); b.className='mb-save'; p.appendChild(b); }
    var txt='Save '+pct+'%'; if(b.textContent!==txt) b.textContent=txt;
  }
  function init(){
    sync();
    var root=document.querySelector('.product__price'); if(!root||!root.parentNode) return;
    new MutationObserver(function(){ sync(); }).observe(root.parentNode,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
